import { SquareLock01Icon, ArrowRight01Icon } from '@hugeicons/react'
import clsx from 'clsx'

import { sanitizeHtml } from '@/shared/lib/html/sanitize'
import { useBlocker } from '@/shared/hooks/useBlocker'
import { useNavigation } from '@/shared/hooks/useNavigation'
import { Button } from '@/shared/ui/Button'
import { Card } from '@/shared/ui'
import type { BlockCondition } from '@/types/blocker'

import { Link } from './Link'

interface BlockerProps {
  blockCondition: BlockCondition
  children: React.ReactNode
  className?: string
}

export const Blocker = ({
  blockCondition,
  children,
  className
}: BlockerProps) => {
  const { navigateTo } = useNavigation()

  const { checkBlockCondition, getBlockMessage } = useBlocker()
  const blockResult = checkBlockCondition(blockCondition)

  if (blockResult.unlocked) return <>{children}</>

  if (!blockResult.firstUnmet) return <>{children}</>

  const { main, confirmLabel, path, resource } = getBlockMessage(
    blockResult.firstUnmet
  )

  return (
    <Card
      className={clsx(
        'p-4 text-center bg-white border border-dashed shadow-sm',
        className
      )}
    >
      <Card.Body className="gap-3 flex flex-col items-center">
        <div className="mb-2 flex items-center justify-center">
          <SquareLock01Icon
            size={50}
            className="p-3 border bg-gray-100 text-info rounded-full"
          />
        </div>

        <h5 className="mb-2 font-bold text-gray-900" style={{ fontSize: 20 }}>
          Conteúdo bloqueado
        </h5>
        <div
          className="mb-3 text-gray-700 text-lg"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(main) }}
        />

        <div className="flex gap-4 items-center">
          <Button variant="secondary" href="/" showTrailingIcon={false}>
            Voltar
          </Button>
          {path && (
            <Button
              variant="success"
              showTrailingIcon={false}
              trailingIcon={<ArrowRight01Icon size={18} />}
              onClick={() => navigateTo(path)}
            >
              {confirmLabel}
            </Button>
          )}
        </div>

        <div className="mt-2 text-gray-700 text-sm">
          Finalize o recurso necessário para liberar o conteúdo.
        </div>
      </Card.Body>
    </Card>
  )
}
